import { Link } from "react-router-dom";
import { ProjectName } from "../../constants/ProjectName";
import { PublicSiteUrl } from "../../constants/PublicSiteUrl";
const logo = "/logo192.png";


export default function PublicHeader({
  prompt = "Not using Therapy Diary App?",
  actionText = "Start free trial",
  actionTo = "/signup",
}) {
  return (
    <header className="public-header">
      <div className="public-container public-header-inner">
        <a href={PublicSiteUrl} className="public-brand">
          <span className="public-brand-logo">
            <img src={logo} alt={`${ProjectName} logo`} />
          </span>

          <span className="public-brand-text">
            <strong>{ProjectName}</strong>
            <small>Simple practice management</small>
          </span>
        </a>

        <div className="public-header-action">
          <span>{prompt}</span>

          <Link to={actionTo} className="public-header-button">
            {actionText}
          </Link>
        </div>
      </div>
    </header>
  );
}